angular.module('CarsSaraBo').directive('itemSelector', function () {
    return {
        scope: {
            name: '@',
            config: '=config',
            items: '=items',
            validations: '=valid',
            errorField: '=error',
            editable: '=editable'
        },

        link: function (scope) {
            var itemsList = [];
            scope.$watch('items', function () {
                for (i in scope.items) {
                    if (scope.items[i].checked == true) {
                        scope.validations.hasAnySelected = true;
                        return;
                    }
                }
                if (scope.validations) {
                    scope.validations.hasAnySelected = false;
                }
            }, true);

            scope.toogleItem = function (oid) {
                if (!scope.items[oid]) {
                    scope.items[oid] = {checked: true};
                } else {
                    scope.items[oid].checked = !scope.items[oid].checked;
                }
            };

            scope.getItemsList = function () {
                if(scope.items && itemsList.length == 0){
                    for (var i in scope.items){
                        itemsList.push({oid: i, name: scope.items[i].name.toLowerCase()})
                    }
                    itemsList = _.sortBy(itemsList, 'name');
                }
                return itemsList;
            }

            scope.checkAll = function (select) {
                for (i in scope.items) {
                    if (!scope.items[i]) {
                        scope.items[i] = {};
                    }
                    scope.items[i].checked = select;
                }
            };

            scope.updateValidation = function (field) {
                if (scope.errorField != undefined && scope.errorField[field]) {
                    scope.errorField[field] = null;
                }
            }
        },
        templateUrl: 'assets/commons/item-selector.html'
    };
});


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/item_selector_directive.js
// module id = 877
// module chunks = 3